import { defineKey as T } from 'ha/i18n';

export const ERROR_MESSAGES = {
  INVALID_PHONE: T('Incorrect phone number'),
  SERVER_ERROR: T(
    'The phone number cannot be verified. Please check if this is a correct number.',
  ),
};
